export const getWaveNumberFromKey = (waveKey) =>
  Number.parseInt(waveKey.slice(1), 10);

export const parseQuantityValue = (value) => {
  if (value === null || value === undefined || value === "" || value === ".") {
    return null;
  }
  const parsed = Number.parseFloat(String(value).replace(",", "."));
  return Number.isFinite(parsed) && parsed !== 0 ? parsed : null;
};

export const getCurrentSeniorDuLevel = (quantities = {}) => {
  if (parseQuantityValue(quantities.strategic_quantity)) return "strategic";
  if (parseQuantityValue(quantities.optimal_quantity)) return "optimal";
  if (parseQuantityValue(quantities.tactical_quantity)) return "tactical";
  return null;
};

export const waveMatchesParityMode = (waveKey, parityMode) => {
  if (parityMode === "all") return true;
  const waveNumber = getWaveNumberFromKey(waveKey);
  const isOdd = waveNumber % 2 === 1;
  return parityMode === "odd" ? isOdd : !isOdd;
};

export const normalizeWavePairsForParity = (wavePairs, parityMode, waveKeys) => {
  const normalized = { ...wavePairs };

  if (parityMode === "all") {
    return normalized;
  }

  waveKeys.forEach((waveKey) => {
    if (!waveMatchesParityMode(waveKey, parityMode)) {
      normalized[waveKey] = false;
    }
  });

  return normalized;
};

export const getDuWaveButtonStateClass = ({
  isDisabled = false,
  isPersistent = false,
  isSelected = false,
}) => {
  if (isDisabled)
    return "bg-gray-100 text-gray-300 border-gray-200 cursor-not-allowed";
  if (isPersistent) return "bg-indigo-600 text-white border-indigo-500";
  if (isSelected) return "bg-purple-500 text-white border-purple-400";
  return "bg-white text-gray-500 border-gray-200 hover:bg-gray-100";
};

export const createInitialDuVisibility = () => ({
  tactical: true,
  optimal: true,
  strategic: true,
});

export const enforceExpandedDuSelector = (prev, levelKey) => ({
  ...prev,
  [levelKey]: true,
});
